module.exports = __webpack_public_path__ + "media/images/flags/md-38aa0a732391597679db496f459d5692.svg";